import { useCallback } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { isFreeTrialActive } from "@jti/fe-common";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { fetchFreeTrialOrder, fetchOrder } from "@jti/store/slices/LEGACY__orderSlice";
import { getOrderItemsWithFormattedPrice } from "@jti/store/utils";

import { useFreeTrial } from "@checkout/hooks/useFreeTrial";
import { useLoyaltyStatus } from "@checkout/hooks/useLoyaltyStatus";

export const useOrder = () => {
  const dispatch = useDispatch();
  const hasLoyalty = useLoyaltyStatus();
  const { isFreeTrial, freeTrialOrderState } = useFreeTrial();
  const config = useConfig();
  const { showPricesWithTaxExcluded = false } = config;

  const currency = useSelector((state) => state.cart.currency);
  const { points, pending_points } = useSelector((state) => state.loyalty);
  const { orderDetails, paymentMethod, contactEmail, points: earnedPoints } = useSelector((state) => state.order);

  const {
    paymentMethod: freeTrialPaymentMethod,
    contactEmail: freeTrialContactEmail,
    points: freeTrialEarnedPoints,
    orderDetails: freeTrialOrder,
  } = freeTrialOrderState;

  const fetchOrderCallback = useCallback(
    (orderId: string) => {
      if (isFreeTrialActive(config) && isFreeTrial) {
        dispatch(fetchFreeTrialOrder({ orderId }));
      } else {
        dispatch(fetchOrder({ orderId, showPricesWithTaxExcluded }));
      }
    },
    [isFreeTrial, dispatch, showPricesWithTaxExcluded]
  );

  const orderData = isFreeTrial ? freeTrialOrder.data : orderDetails?.data;
  const currentOrder = getOrderItemsWithFormattedPrice(orderData, currency, showPricesWithTaxExcluded);
  const orderFetchStatus = isFreeTrial ? freeTrialOrder.fetchStatus : orderDetails.fetchStatus;
  const summaryPrices = isFreeTrial ? freeTrialOrder.data?.prices : currentOrder?.prices;

  return {
    orderFetchStatus,
    order: currentOrder,
    fetchOrder: fetchOrderCallback,
    contactEmail: isFreeTrial ? freeTrialContactEmail : contactEmail,
    paymentMethod: isFreeTrial ? freeTrialPaymentMethod : paymentMethod,
    earnedPoints: isFreeTrial ? freeTrialEarnedPoints : earnedPoints,
    hasLoyalty,
    points,
    pending_points,
    isFreeTrial,
    summaryPrices,
  };
};
